module.exports = __webpack_public_path__ + "static/img/lx_blue.3af3f152.svg";